import { useEffect } from 'react';
import LandingPageInteractive from './landing-page/components/LandingPageInteractive';

const title = 'D.Y. Patil Online MBA - Upgrade Your Career Without Quitting Your Job';
const description =
  'Join 15,000+ working professionals advancing their careers with UGC-approved Online MBA. Flexible learning, affordable fees, and career-focused specializations. Apply now for free counseling.';

export default function LandingPage() {
  useEffect(() => {
    const prevTitle = document.title;
    const meta = document.querySelector('meta[name="description"]');
    const prevDescription = meta?.getAttribute('content') ?? null;
    document.title = title;
    meta?.setAttribute('content', description);
    return () => {
      document.title = prevTitle;
      if (prevDescription !== null) meta?.setAttribute('content', prevDescription);
    };
  }, []);

  return <LandingPageInteractive />;
}
